import type { PropsWithChildren, ReactNode } from 'react';
import styles from '../order-details.upp.module.scss';

export function DescriptionList({ children }: PropsWithChildren) {
  return <dl className={styles.descriptionList}>{children}</dl>;
}

type DescriptionPairProps = {
  term: string;
  description: ReactNode;
  inline?: boolean;
  lightDescription?: boolean;
};

export function DescriptionPair(props: DescriptionPairProps) {
  const { term, description, inline, lightDescription } = props;
  const lightDescriptionClass = lightDescription
    ? styles.descriptionDetailsLight
    : '';

  return (
    <div
      className={inline ? styles.descriptionPairInline : styles.descriptionPair}
    >
      <dt className={styles.descriptionTerm}>{term}:</dt>
      <dd className={`${styles.descriptionDetails} ${lightDescriptionClass}`}>
        {description}
      </dd>
    </div>
  );
}
